import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Panel,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  GRID_VARIANT_VERTICAL_BIG,
  Text,
  Title,
  TITLE_VARIANT_M,
  TITLE_VARIANT_S,
  SpacingVertical,
  SPACING_8,
  Badge,
  HelpIcon,
  SPACING_4,
  TooltipUtils,
  SkeletonLoader
} from 'mailup-web-components'
import moment from 'moment-timezone'
import { progressState } from 'Pages/EmailSendingWizard/recoil/state/queue'
import { notifyParent } from 'Helpers/notifyParent'

import {
  fromUTCtoZoneFormatted,
  STORE_KEY_ACCOUNT,
  STORE_KEY_FEATURES,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'
import styled from '@emotion/styled'
import {
  abitudiniApertureState,
  smartPlanningState
} from 'Pages/EmailSendingWizard/recoil/state/page'
import iconSendQueueOpenrate from 'Img/icon-send-queue-openrate.svg'
import iconSmartPlanning from 'Img/icon-smart-planning.svg'
import iconSendQueueRecipients from 'Img/icon-send-queue-recipients.svg'
import iconSendQueueTime from 'Img/icon-send-queue-time.svg'
import arrowUpRightFromSquareSolid from 'Img/arrow-up-right-from-square-solid.svg'
import aiLightningWhite from 'Img/ai-lightning-white.svg'
import {
  evaluateSendingBestPlanningTimeCallback,
  getSmartPlanningSuggestedDateCallback
} from 'Pages/EmailSendingWizard/recoil/callbacks/callback'
import {
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'
import { isScheduledSendingState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import { MODE_SMART } from 'Constants/index'

const StyledIconUpsellClick = styled.img`
  position: relative;
  top: -1px;
`

const StyledBadgeNew = styled(Badge)`
  position: absolute;
  top: 26px;
  height: 16px;
  left: -4px;
  padding: 6px 4px 4px 4px;
  font-size: 11px;
`

const StyledBadgeAIGradient = styled(Badge)`
  font-size: 11px;
  padding: 8px 6px;
  background-color: white;
  border: 0;
  color: white;
  background: linear-gradient(to right, #762eef, #3dc6f5);
  height: 19px;
`

const StyledFlexItem = styled(FlexItem)`
  position: relative;
`

const StyledLinkUpsellClick = styled(Link)`
  font-size: 14px;
`

const BoxTotalRecipientsNew = () => {
  const intl = useIntl()
  const [fTime, setFtime] = useState('')
  const { toBeQueued, estimatedSendingTime, queueStatus } = useRecoilValue(
    progressState
  )
  const {
    avaible: abitudiniAvaible,
    loading: abitudiniLoading,
    bestValue: abitudiniBestValue
  } = useRecoilValue(abitudiniApertureState)

  const evaluateSendingBestPlanningTime = useRecoilCallback(
    evaluateSendingBestPlanningTimeCallback,
    []
  )
  const {
    smartPlanningDate,
    smartPlanningDateLoaded,
    smartPlanningError
  } = useRecoilValue(smartPlanningState)
  const getSmartPlanningSuggestedDate = useRecoilCallback(
    getSmartPlanningSuggestedDateCallback,
    []
  )
  const setIsScheduledSending = useSetRecoilState(isScheduledSendingState)

  const tzcode = storeGet(STORE_KEY_LIST).TimeZoneCode
  const account = storeGet(STORE_KEY_ACCOUNT)

  const consoleFreq = account.IdOffer === 2 // FREQUENZA

  const { IsTrial: isTrial } = storeGet(STORE_KEY_ACCOUNT)

  const smartPlanningFeature =
    storeGet(STORE_KEY_FEATURES).indexOf('smartPlanning') >= 0

  const showSmartPlanning =
    smartPlanningFeature &&
    account.IdOffer !== 3 &&
    account.IdOffer !== 2 &&
    account.IdOffer !== 6 &&
    !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA - SOLOSMS-LIGHT

  const formatTime = () => {
    const secondsTime = moment.duration(estimatedSendingTime, 'seconds')
    const d = secondsTime.days()
    const h = secondsTime.hours()
    const m = secondsTime.minutes()
    const s = secondsTime.seconds()

    return `${intl.formatNumber(d)}d ${String(h).padStart(2, '0')}h ${String(
      m
    ).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`
  }

  useEffect(() => {
    setFtime(formatTime())
  }, [estimatedSendingTime])

  useEffect(() => {
    if (queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED) {
      getSmartPlanningSuggestedDate()
    }
  }, [queueStatus])

  const handleUpsellClick = () => {
    const { Domain } = storeGet(STORE_KEY_ACCOUNT)
    const route = '/console/mshop_Redirector.aspx?t=mshopem'

    notifyParent('openNewTab', [
      `https://${Domain}/console/Main.aspx#/main?pageId=EmailMessageEditHtml&pageHref=${encodeURIComponent(
        route
      )}`
    ])
  }

  const handleClickCalculate = () => {
    evaluateSendingBestPlanningTime()
  }

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [abitudiniBestValue])

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [abitudiniAvaible])

  const applySmartPlanning = () => {
    setIsScheduledSending(prev => ({
      ...prev,
      isScheduledSending: true,
      scheduleModeSelected: MODE_SMART
    }))
  }

  return (
    <>
      <Panel>
        <Grid cols={12} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
          <GridCell span={4}>
            <Flex padding='16px 0 8px 0'>
              <FlexItem padding='0 16px 8px 0'>
                <img src={iconSendQueueRecipients} />
              </FlexItem>
              <Flex flexDirection='column'>
                <Text variant='light'>
                  {intl.formatMessage({
                    id: 'Load.QueueStatus.RecipientsTotalShort'
                  })}
                </Text>
                <SpacingVertical variant={SPACING_8} />

                {toBeQueued > 0 ? (
                  <Title variant={TITLE_VARIANT_M}>
                    {intl.formatNumber(toBeQueued)}
                  </Title>
                ) : (
                  <SkeletonLoader width='200px' height='18px' />
                )}
              </Flex>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex padding='16px 0 8px 0'>
              <FlexItem padding='0 16px 8px 0'>
                <img src={iconSendQueueTime} />
              </FlexItem>
              <Flex flexDirection='column'>
                <Text variant='light'>
                  {intl.formatMessage({ id: 'Load.Queue.EstimatedTimeShort' })}
                </Text>
                <SpacingVertical variant={SPACING_8} />

                {estimatedSendingTime === undefined ? (
                  <SkeletonLoader width='200px' height='18px' />
                ) : (
                  <Title variant={TITLE_VARIANT_M}>{fTime}</Title>
                )}
                <SpacingVertical variant={SPACING_4} />
                <StyledLinkUpsellClick
                  variant={LINK_VARIANT_HIGHLIGHT}
                  onClick={handleUpsellClick}
                >
                  {intl.formatMessage({
                    id: 'Load.Queue.TempoStimatoUpsellingBandaIntl'
                  })}
                  &nbsp;
                  <StyledIconUpsellClick src={arrowUpRightFromSquareSolid} />
                </StyledLinkUpsellClick>
              </Flex>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex
              padding='16px 0 8px 0'
              data-tip={
                consoleFreq
                  ? intl.formatMessage({
                      id: 'Load.Queue.BestOpenTimeTooltipNotAvailableSales'
                    })
                  : ''
              }
            >
              {showSmartPlanning && (
                <>
                  <StyledFlexItem padding='0 16px 8px 0'>
                    <img src={iconSmartPlanning} />
                  </StyledFlexItem>
                  <Flex flexDirection='column'>
                    <Flex alignItems='center' gap='4px'>
                      <Text variant='light'>
                        {intl.formatMessage({
                          id: 'Load.QueueStatus.AiPlanningTitle'
                        })}
                      </Text>
                      <StyledBadgeAIGradient
                        type='info'
                        kind='default'
                        text={
                          <Flex alignItems='center' gap='2px'>
                            BETA AI
                            <img src={aiLightningWhite} />
                          </Flex>
                        }
                      />
                      <HelpIcon
                        text={intl.formatMessage({
                          id: 'Load.QueueStatus.AiPlanningTooltip'
                        })}
                      />
                    </Flex>
                    <SpacingVertical variant={SPACING_8} />
                    {smartPlanningDateLoaded ? (
                      <>
                        {!smartPlanningError && (
                          <>
                            {smartPlanningDate && (
                              <Flex gap='4px' alignItems='baseline'>
                                <Title variant={TITLE_VARIANT_M}>
                                  {fromUTCtoZoneFormatted(
                                    smartPlanningDate,
                                    tzcode,
                                    'YYYY/MM/DD - HH:mm'
                                  )}
                                </Title>
                                <Text variant='small-light'>{`(${
                                  tzcode.split('.')[0]
                                })`}</Text>
                              </Flex>
                            )}
                            {!smartPlanningDate && (
                              <Title variant={TITLE_VARIANT_S}>-</Title>
                            )}
                          </>
                        )}
                        {smartPlanningError === 'NoData' && (
                          <Title variant={TITLE_VARIANT_M}>
                            {intl.formatMessage({
                              id: 'Load.QueueStatus.AiPlanningNoData'
                            })}
                          </Title>
                        )}
                        {smartPlanningError === 'DataError' && (
                          <Title variant={TITLE_VARIANT_M}>
                            {intl.formatMessage({
                              id: 'Load.QueueStatus.AiPlanningDataError'
                            })}
                          </Title>
                        )}
                        <SpacingVertical variant={SPACING_4} />
                      </>
                    ) : (
                      <SkeletonLoader width='200px' height='18px' />
                    )}

                    <Link
                      disabled={
                        !smartPlanningDate ||
                        queueStatus === BEQUEUE_CONFIG_STATE_RUNNING ||
                        queueStatus === BEQUEUE_CONFIG_STATE_FAILED ||
                        smartPlanningError
                      }
                      variant={LINK_VARIANT_HIGHLIGHT}
                      onClick={applySmartPlanning}
                      data-mu-test='link-AiPlanningApply'
                    >
                      {intl.formatMessage({
                        id: 'Load.QueueStatus.AiPlanningApply'
                      })}
                    </Link>
                  </Flex>
                </>
              )}
              {!showSmartPlanning && (
                <>
                  <StyledFlexItem padding='0 16px 8px 0'>
                    <StyledBadgeNew
                      type='info'
                      kind='secondary'
                      text={intl.formatMessage({
                        id: 'Load.Queue.NewBadge'
                      })}
                    />
                    <img src={iconSendQueueOpenrate} />
                  </StyledFlexItem>
                  <Flex flexDirection='column'>
                    <Text variant='light'>
                      {intl.formatMessage({
                        id: 'Load.Queue.BestOpenTime'
                      })}
                    </Text>
                    <SpacingVertical variant={SPACING_8} />
                    {!abitudiniLoading && (
                      <>
                        <Title variant={TITLE_VARIANT_M}>
                          {abitudiniAvaible &&
                            !abitudiniBestValue &&
                            !consoleFreq &&
                            intl.formatMessage({
                              id: 'Load.Queue.BestOpenTimeTbc'
                            })}
                          {((!abitudiniAvaible && !abitudiniBestValue) ||
                            consoleFreq) && (
                            <>
                              {intl.formatMessage({
                                id: 'Load.Queue.BestOpenTimeNotAvailable'
                              })}
                              {!consoleFreq && (
                                <HelpIcon
                                  text={intl.formatMessage({
                                    id: isTrial
                                      ? 'Load.Queue.BestOpenTimeTooltipNotAvailable'
                                      : 'Load.Queue.BestOpenTimeTooltipFailed'
                                  })}
                                />
                              )}
                            </>
                          )}
                          {abitudiniBestValue && (
                            <>
                              {abitudiniBestValue}
                              <HelpIcon
                                text={intl.formatMessage({
                                  id: 'Load.Queue.BestOpenTimeTooltipSuccess'
                                })}
                              />
                            </>
                          )}
                        </Title>
                        {!abitudiniAvaible &&
                          !abitudiniBestValue &&
                          consoleFreq && (
                            <>
                              <SpacingVertical variant={SPACING_4} />
                              <Link disabled variant={LINK_VARIANT_HIGHLIGHT}>
                                {intl.formatMessage({
                                  id: 'Load.Queue.BestOpenTimeCalcCta'
                                })}
                              </Link>
                            </>
                          )}
                      </>
                    )}
                    {abitudiniLoading && (
                      <SkeletonLoader width='200px' height='18px' />
                    )}
                    {!abitudiniBestValue && abitudiniAvaible && (
                      <>
                        <SpacingVertical variant={SPACING_4} />
                        <Link
                          disabled={
                            !abitudiniAvaible || abitudiniLoading || consoleFreq
                          }
                          variant={LINK_VARIANT_HIGHLIGHT}
                          onClick={handleClickCalculate}
                          data-mu-test='link-best-open-time'
                        >
                          {!abitudiniLoading
                            ? intl.formatMessage({
                                id: 'Load.Queue.BestOpenTimeCalcCta'
                              })
                            : intl.formatMessage({
                                id: 'Load.Queue.BestOpenTimeCalcLoad'
                              })}
                        </Link>
                      </>
                    )}
                  </Flex>
                </>
              )}
            </Flex>
          </GridCell>
        </Grid>
      </Panel>
    </>
  )
}

export default BoxTotalRecipientsNew
